import { render } from "./dispatch-device-table.vue?vue&type=template&id=78d2e458&ts=true"
import script from "./dispatch-device-table.ts?vue&type=script&lang=ts"
export * from "./dispatch-device-table.ts?vue&type=script&lang=ts"

import "./dispatch-device-table.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__